export var selectInitialSelectedFolderIds = function selectInitialSelectedFolderIds(state) {
  return state.favoritesAssignWidget.initialSelectedFolderIds;
};